import { Injectable } from '@angular/core'
import { NavigationExtras } from '@angular/router'
import { AuctionsConstants } from 'libs/gb-dashboard/auctions/feature/src/lib/auctions.constants'
import { take } from 'rxjs'
import { SelectedAuctionFacade } from 'libs/gb-dashboard/auctions/data-access-selected-auction/src/lib/+state/selected-auction.facade'
import { GbNavigationService } from 'libs/shared/utils/services/src/lib/gb-navigation-service/gb-navigation.service'

@Injectable({
  providedIn: 'root',
})
export class GbRouterService {
  // TODO: GB-11207 refactor the router usages to use this service instead

  constructor(
    private selectedAuctionFacade: SelectedAuctionFacade,
    private gbNavigationService: GbNavigationService,
  ) {}

  navigateToSelectedAuctionHome(newTab = false, extras?: NavigationExtras) {
    this.selectedAuctionFacade.urlName$.pipe(take(1)).subscribe((urlName) => {
      if (urlName) {
        this.gbNavigationService.navigate([`/${AuctionsConstants.AUCTION}/${urlName}`], {
          newTab,
          extras,
        })
      }
    })
  }

  navigateToSelectedAuctionRoute(pathSegments: string[], newTab = false, extras?: NavigationExtras) {
    this.selectedAuctionFacade.urlName$.pipe(take(1)).subscribe((urlName) => {
      if (urlName) {
        this.gbNavigationService.navigate([`/${AuctionsConstants.AUCTION}/${urlName}`, ...pathSegments], {
          newTab,
          extras,
        })
      }
    })
  }
}
